export default (product) => !!(product && product.finalSale);
